import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import {
  Box,
  Button,
  Divider,
  MenuItem,
  Modal,
  TextField,
  Typography
} from '@mui/material';

import LoadingButton from '../../../components/buttons/Button';

import {
  CreateAuthorityCERT
} from '../../../redux/actions/certification/authoritiesActions';

import global from "../../../global.scss";

const Data = {
  FirstName: "",
  LastName: "",
  UserName: "",
  PrimaryEmail: "",
  AuthorityName: "",
  Type: "",
};

const typeOptions = [
  { label: "DBE", value: "DBE" },
];

const AuthoritiesModal = ({
  open,
  setOpen,
  title,
  update,
  handleGet
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(Data);
  const [mode, setMode] = useState(1);

  const handleClose = () => {
    setOpen(false);
    setFormData(Data);
    setMode(1);
  };

  useEffect(() => {
    try {
      if (open) {
        if (update?.defaultMode === 1 || !update?.defaultMode) {
          // mode = 1 - create authority
          setMode(1);
        } else {
          toast.error("Invalid modal");
          handleClose();
        }
      }
    } catch (err) {
      console.log(err);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    if (mode === 1) {
      let obj = {
        first_name: formData.FirstName || "",
        last_name: formData.LastName || "",
        user_name: formData.UserName || "",
        primary_email: formData.PrimaryEmail || "",
        authority_name: formData.AuthorityName || "",
        type: formData.Type || "",
      };
      dispatch(CreateAuthorityCERT(obj, setLoading)).then(() => {
        handleGet().then(() => {
          handleClose();
        });
      });
    } else {
      toast.error("Invalid modal");
      handleClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box className="flexCenterCenterRow"
        width={"100vw"} height={"100vh"}>
        <Box maxWidth={"sm"} className="modal">
          <Box width={"100%"}
            sx={{ padding: "15px"}}>
            <Typography variant='h6' sx={{ color: global["primary"] }} mb={"20px"}>
              {title}
            </Typography>
            <Box
              className="flexCenterSBRow"
              gap={"15px"}
              mb={"15px"}>
              <TextField
                label="First Name"
                fullWidth
                name="FirstName"
                value={formData.FirstName}
                onChange={handleChange}
                inputProps={{ maxLength: 64 }}
                />
              <TextField
                label="Last Name"
                fullWidth
                name="LastName"
                value={formData.LastName}
                onChange={handleChange}
                inputProps={{ maxLength: 64 }}
                />
            </Box>
            <Box
              className="flexCenterSBRow"
              gap={"15px"}
              mb={"15px"}>
              <TextField
                label="Username"
                fullWidth
                name="UserName"
                value={formData.UserName}
                onChange={handleChange}
                inputProps={{ maxLength: 128 }}
                />
              <TextField
                label="Primary Email"
                fullWidth
                name="PrimaryEmail"
                value={formData.PrimaryEmail}
                onChange={handleChange}
                inputProps={{ maxLength: 128 }}
                />
            </Box>
            <Box
              className="flexCenterSBRow"
              gap={"15px"}
              mb={"15px"}>
              <TextField
                label="Authority Name"
                fullWidth
                name="AuthorityName"
                value={formData.AuthorityName}
                onChange={handleChange}
                inputProps={{ maxLength: 128 }}
                />
              <TextField
                label="Type"
                fullWidth
                select
                name="Type"
                value={formData.Type}
                onChange={handleChange}>
                {typeOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          </Box>
          <Divider
            sx={{ backgroundColor: "rgba(44, 45, 47, 1)" }}/>
          <Box className="flexCenterFERow" sx={{ gap: "20px", margin: "15px"}}>
            <Button variant='text'
              onClick={handleClose}>
              Cancel
            </Button>
            <LoadingButton
              variant='contained'
              loading={loading}
              disabled={!(formData.UserName !== "" && formData.PrimaryEmail !== "")}
              onClick={handleSubmit}>
              Submit
            </LoadingButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default AuthoritiesModal;
